export default __webpack_public_path__ + "static/media/Polaris Logo.e62f3e27.svg";